<template>
    <div class="dialog">
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="title"
            custom-class="green-dialog"
            :visible.sync="isShowDialog"
            :width="width"
            :destroy-on-close="true"
        >
            <slot></slot>
            <div class="dialog-footer">
                <el-button v-if="isShowButton[0]" @click="cancel">取 消</el-button>
                <el-button v-if="isShowButton[1]" style="margin-left: 30px" type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "Dialog",
    data() {
        return {
            isShowDialog: false,
        };
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        isShowButton: {
            type: Array,
            default() {
                return [true, true];
            },
        },
        cancelHandler: {
            type: Function,
            default() {
                return function() {};
            },
        },
        confirmHandler: {
            type: Function,
            default() {
                return function() {};
            },
        },
        width: {
            type: String,
            default: "650px",
        },
    },
    components: {},
    methods: {
        open() {
            this.isShowDialog = true;
        },
        close() {
            this.isShowDialog = false;
        },
        confirm() {
            // this.close();
            this.confirmHandler();
        },
        cancel() {
            this.close();
            this.cancelHandler();
        },
    },
};
</script>

<style scoped lang="scss">
.dialog {
}
::v-deep .green-dialog {
    .el-dialog__body {
        padding: 22px 24px;

        .el-form-item {
            margin-bottom: 26px;
        }

        .el-form-item__label {
            padding: 0;
            line-height: 1;
            font-size: 16px;
            color: #333333;
            margin-bottom: 10px;
        }

        .dialog-footer {
            text-align: center;
            margin-top: 20px;
        }

        .allot-class,
        .allot-class-two {
            &.allot-class-two .el-cascader-menu {
                width: 50%;

                &:last-of-type {
                    border-right: none;
                }
            }

            &.allot-class .el-cascader-menu {
                width: calc(100% / 3);

                &:nth-child(3) {
                    border-right: none;
                }
            }

            .el-cascader-menu {
                border-right: 1px solid #e4e7ed;

                .el-cascader-menu__wrap {
                    height: 286px;

                    .el-cascader-menu__list {
                        .el-cascader-node {
                            &:hover {
                                background: #e7f6ef;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
